import * as React from "react";

import { cn } from "@/lib/utils";

interface TextareaProps extends React.ComponentProps<"textarea"> {
  variant?: "default" | "inset-label";
  label?: string;
}

function Textarea({
  className,
  variant = "default",
  label,
  ...props
}: TextareaProps) {
  const id = React.useId();

  if (variant === "inset-label") {
    return (
      <div className="border-input bg-background focus-within:border-ring focus-within:ring-ring/50 has-aria-invalid:ring-destructive/20 dark:has-aria-invalid:ring-destructive/40 has-aria-invalid:border-destructive relative w-full  rounded-md border shadow-xs transition-[color,box-shadow] outline-none focus-within:ring-[3px] has-disabled:pointer-events-none has-disabled:cursor-not-allowed has-disabled:opacity-50 has-[input:is(:disabled)]:*:pointer-events-none">
        <label
          htmlFor={id}
          className="text-foreground block px-3 pt-1 text-xs font-medium"
        >
          {label || "Textarea with inset label"}
        </label>
        <textarea
          id={id}
          className={cn(
            "text-foreground placeholder:text-muted-foreground/70 flex min-h-4 w-full px-3 pb-2 text-sm focus-visible:outline-none",
            className
          )}
          {...props}
        />
      </div>
    );
  }

  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
